import * as Yup from 'yup'

const doValidation = (val, fieldId, checkBox, hasSelectedHighlights) =>
  !!val?.trim() || !!hasSelectedHighlights(fieldId) || checkBox

const validationSchema = (hasSelectedHighlights) => {
  return Yup.object()
    .shape({
      nameType: Yup.string().required('Name type is required'),
      givenField: Yup.string()
        .test('has-highlight-or-checkbox', 'Given name requires a highlight or checkbox selection.', (val, context) => {
          const { givenNameFieldId, givenCheckbox, surnameField, surnameFieldId, surnameCheckbox } = context.parent
          const validSurname = doValidation(surnameField, surnameFieldId, surnameCheckbox, hasSelectedHighlights)
          if (!validSurname) {
            return doValidation(val, givenNameFieldId, givenCheckbox, hasSelectedHighlights) // givenName Validation
          }

          return true // Skip validation if surnameField is valid
        })
        .nullable(),
      surnameField: Yup.string()
        .test('has-highlight-or-checkbox', 'Surname requires a highlight or checkbox selection.', (val, context) => {
          const { surnameFieldId, surnameCheckbox, givenField, givenNameFieldId, givenCheckbox } = context.parent
          const validGivenName = doValidation(givenField, givenNameFieldId, givenCheckbox, hasSelectedHighlights)
          if (!validGivenName) {
            return doValidation(val, surnameFieldId, surnameCheckbox, hasSelectedHighlights) // givenName Validation
          }

          return true // Skip validation if givenField is valid
        })
        .nullable(),
    })
    .test(
      'at-least-one-field',
      'At least one of "givenField" (with highlight/checkbox) or "surnameField" (with highlight/checkbox) must be provided.',
      (values) => {
        const { givenField, surnameField, givenNameFieldId, surnameFieldId, givenCheckbox, surnameCheckbox } =
          values || {}

        return !!(
          (givenField && (givenCheckbox || !!hasSelectedHighlights(givenNameFieldId))) ||
          (surnameField && (surnameCheckbox || !!hasSelectedHighlights(surnameFieldId)))
        )
      }
    )
}

export default validationSchema
